import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { UserSearchDialogComponent } from './user-search-dialog.component';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';

@Injectable()
export class UserSearchDialogService {
  constructor(private dialog: MatDialog) {}

  public open(data): Observable<UserSearchResult> {
    let dialogRef: MatDialogRef<UserSearchDialogComponent>;
    dialogRef = this.dialog.open(UserSearchDialogComponent, {
      data,
    });
    return dialogRef.afterClosed();
  }
}
